import React from 'react';
import BaseParametroCrud from './BaseParametroCrud';

export default function EntidadRelacionDDHH() {
    return (
        <BaseParametroCrud
            header={{
                title: 'Entidades relación DDHH',
                idCabezaFamilia: '1',
                url: '/parametros',
                nombreurl: 'Parámetros',
                nombreform: 'Entidades relación DDHH'
            }}
            formTitle="Formulario entidades relación DDHH"
            loadUrl="/parametros/entidadrelacionddhh"
            saveUrl="/parametros/guardarentidadrelacionddhh"
            alertTitle="Guardar entidades relación DDHH"
            defaultValues={{
                id: 0,
                strNombre: '',
                bolActivo: false,
                bolRecibeDenuncia: false,
                bolActivaRuta: false
            }}
            mapRowToForm={(row) => ({
                id: row.id,
                strNombre: row.strNombre,
                bolActivo: row.bolActivo,
                bolRecibeDenuncia: row.bolRecibedenuncia,
                bolActivaRuta: row.bolActivaruta
            })}
            columns={[
                { key: 'id', title: 'Id' },
                { key: 'strNombre', title: 'Nombre' },
                {
                    key: 'bolActivo',
                    title: 'Estado',
                    render: (row) => (row.bolActivo ? 'Activo' : 'Inactivo')
                },
                {
                    key: 'bolRecibeDenuncia',
                    title: 'Recibe Denuncia',
                    render: (row) => (row.bolRecibedenuncia ? 'Sí' : 'No')
                },
                {
                    key: 'bolActivaRuta',
                    title: 'Activa Ruta',
                    render: (row) => (row.bolActivaruta ? 'Sí' : 'No')
                }
            ]}
            renderFormFields={({ register, errors }) => (
                <>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <label htmlFor="strNombre">Nombre</label>
                                <input
                                    {...register('strNombre', { required: true })}
                                    className="form-control"
                                    placeholder="Nombre"
                                    id="strNombre"
                                />
                                {errors.strNombre && <p style={{ color: 'red' }}>Digitar dato</p>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolActivo')}
                                        className="custom-control-input"
                                        id="SwitchEstado"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchEstado">Estado</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolRecibeDenuncia')}
                                        className="custom-control-input"
                                        id="SwitchRecibeDenuncia"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchRecibeDenuncia">Recibe Denuncia</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="form-group">
                                <div className="custom-control custom-switch">
                                    <input
                                        type="checkbox"
                                        {...register('bolActivaRuta')}
                                        className="custom-control-input"
                                        id="SwitchActivaRuta"
                                    />
                                    <label className="custom-control-label" htmlFor="SwitchActivaRuta">Activa Ruta</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        />
    );
}